import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import Swal from 'sweetalert2';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';

import {
  FormBuilder,
  Validators,
  FormControl,
  FormGroup,
  FormArray,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-feedback-manager-sub',
  templateUrl: './feedback-manager-sub.component.html',
  styleUrls: ['./feedback-manager-sub.component.scss'],
})
export class FeedbackManagerSubComponent implements OnInit {
  all_urls: any;
  url_form: FormGroup;
  submitted = false;
  editFG: FormGroup;
  countdata: any;
  ending: any = { end: -2, title: '' };
  whatsapp_cb = '0';
  review_cb = '0';
  whatsapp_cb_checked: boolean = false;
  review_cb_checked: boolean = false;
  userType: any;


  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    const { userType } = this.local.getUser();
    this.userType = userType;
    this.get_url_and_sms_content_sub();
    this.vip_token_transactions();
    this.url_form = this.fb.group({
      url_name: ['', [Validators.required]],
      review_link: ['', [Validators.required]],
      Whatsapp_link: ['', [Validators.required]],
      sms_content: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });

    this.editFG = new FormGroup({
      url_name: new FormControl(''),
      Whatsapp_link: new FormControl(''),
      review_link: new FormControl(''),
      version: new FormControl(''),
      sms_content: new FormControl(''),
      loggedInAdminId: new FormControl(''),
      data_id: new FormControl(''),
    });
  }


  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => {
      this.ending = response.body.ending;
      if (this.ending.end == -1 && this.userType != "Admin") {

        // window.location.href = '/#/new-dashboard/';
      }
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }
  get url_form_v() {
    return this.url_form.controls;
  }

  get_url_and_sms_content_sub() {
    this.auth.get_url_and_sms_content_sub().subscribe((response: any) => {
      this.all_urls = response.body;
    });
  }

  del_url_and_sms_content(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete the feedback manager!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        formData.append('feedback_manager_id', id);

        this.auth
          .del_url_and_sms_content(formData)
          .subscribe((response: any) => {
            this.get_url_and_sms_content_sub();
            window.location.reload()
          });
      }
    });
  }

  add_url_and_sms_content_sub() {
    this.submitted = true;

    if (this.url_form.invalid) {
      return;
    }

    if (
      this.url_form.value.url_name.trim() == 'feedback' ||
      this.url_form.value.url_name.trim() == 'feedbacks'
    ) {
      this.toastr.error('Please use another URL except feedback.');
      return;
    }

    let formData = new FormData();
    formData.append('url_name', this.url_form.value.url_name);
    formData.append('Whatsapp_link', this.url_form.value.Whatsapp_link);
    formData.append('review_link', this.url_form.value.review_link);
    formData.append('sms_content', this.url_form.value.sms_content);
    formData.append('version', this.url_form.value.version);
    formData.append('show_whatsapp_link', this.whatsapp_cb);
    formData.append('show_review_link', this.review_cb);

    this.auth.add_url_and_sms_content_sub(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.url_form.reset();
        this.submitted = false;
        this.get_url_and_sms_content_sub();
        window.location.reload()
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  editReview(content, data) {
    const {
      loggedInAdminId,
      url_name,
      Whatsapp_link,
      review_link,
      version,
      sms_content,
      id,
      show_whatsapp_link,
      show_review_link
    } = data;
    this.editFG.patchValue({
      url_name: url_name,
      Whatsapp_link: Whatsapp_link,
      review_link: review_link,
      version: version,
      sms_content: sms_content,
      data_id: id,
      loggedInAdminId: loggedInAdminId,
    });
    this.whatsapp_cb = show_whatsapp_link;
    this.review_cb = show_review_link;
    this.whatsapp_cb_checked = (show_whatsapp_link == 1) ? true : false;
    this.review_cb_checked = (show_review_link == 1) ? true : false;
    this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      windowClass: 'fm_help_sns'
    });
  }

  edit_update_feedback_manager() {
    this.editFG.value.show_whatsapp_link = this.whatsapp_cb;
    this.editFG.value.show_review_link = this.review_cb;
    this.auth.edit_update_feedback_manager(this.editFG.value).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        this.get_url_and_sms_content_sub();
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  helpSection(content, test) {
    this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
      windowClass: 'fm_help_sns'
    });
    this.countdata = test
  }

  change_whatsapp_cb(event) {
    this.whatsapp_cb = event.target.checked == true ? '1' : '0';
  }

  change_review_cb(event) {
    this.review_cb = event.target.checked == true ? '1' : '0';
  }
}
